(function () {
    'use strict';
    $(document).ready(function () {

        $(".play-video").modalVideo({
            channel: 'vimeo'
        });

        $('.homepage .swiper-news').each(function (index) {
            var newsSwiper = new Swiper($(this)[0], {
                slidesPerView: 3,
                spaceBetween: 40,
                breakpoints: {
                    767: {
                        slidesPerView: 2,
                    },
                    575: {
                        slidesPerView: 1,
                    }
                },
                navigation: {
                    nextEl: '.homepage .news .swiper-button-next',
                    prevEl: '.homepage .news .swiper-button-prev',
                },
            });
        });

        if (window.matchMedia("(max-width: 767px)").matches) {
            gsap.to(".homepage .swiper-news .swiper-wrapper", {
                scrollTrigger: {
                    trigger: ".homepage .swiper-news",
                    start: "top 25%",
                    end: "bottom top",
                    //scrub: true,
                },
                transform: 'translate3d(-80px, 0px, 0px)'
            });
        }

        $('.homepage .swiper-programs').each(function (index) {
            var programsSwiper = new Swiper($(this)[0], {
                slidesPerView: 3,
                spaceBetween: 60,
                direction: 'vertical',
                breakpoints: {
                    767: {
                        direction: 'horizontal',
                        slidesPerView: 2,
                        spaceBetween: 40,
                    },
                    575: {
                        direction: 'horizontal',
                        slidesPerView: 1,
                        spaceBetween: 40,
                    }
                },
                navigation: {
                    nextEl: '.homepage .programs .swiper-button-next',
                    prevEl: '.homepage .programs .swiper-button-prev',
                },
            });
        });

        if (window.matchMedia("(max-width: 767px)").matches) {
            gsap.to(".homepage .swiper-programs .swiper-wrapper", {
                scrollTrigger: {
                    trigger: ".homepage .swiper-programs",
                    start: "top 25%",
                    end: "bottom top",
                    //scrub: true,
                },
                transform: 'translate3d(-80px, 0px, 0px)'
            });
        }

        $('.homepage .swiper-publications').each(function (index) {
            var publicationsSwiper = new Swiper($(this)[0], {
                slidesPerView: 4,
                spaceBetween: 40,
                breakpoints: {
                    767: {
                        slidesPerView: 3,
                    },
                    575: {
                        slidesPerView: 2,
                    },
                    320: {
                        slidesPerView: 1,
                    }
                },
                navigation: {
                    nextEl: '.homepage .publications .swiper-button-next',
                    prevEl: '.homepage .publications .swiper-button-prev',
                },
            });
        });

        if (window.matchMedia("(max-width: 767px)").matches) {
            gsap.to(".homepage .swiper-publications .swiper-wrapper", {
                scrollTrigger: {
                    trigger: ".homepage .swiper-publications",
                    start: "top 25%",
                    end: "bottom top",
                    //scrub: true,
                },
                transform: 'translate3d(-80px, 0px, 0px)'
            });
        }

    });
}(jQuery));
